export default "__VITE_ASSET__TF9jgaUx__"